module.exports = __webpack_public_path__ + "img/05.90d243ce.jpg";